<template>
    <div class="meeting-list">
        <header class="lmy-header lmy-header-w" >
            <i class="iconfont icon-yuyin" @click="routetokPage('/user')"></i>
	            会议预定
	    </header>
        <!--
        <ul class="aMeeting">
            <li v-for="(item ,index) in list" :key="index">
                <div class="top">
                    <span class="msg">{{item.HoldingTime.split("T")[0].split("-")[1]}}.{{item.HoldingTime.split("T")[0].split("-")[2]}} | {{item.MettingVenue}} | {{item.NumberOfPeopleDesc}} | {{item.MettingTypeDesc}}</span>
                    <span class="state">{{item.IsSucceed?'已完成':'未完成'}}</span>
                </div>
                <p class="stateTxt" v-if="!item.IsSucceed">等待顾问致电，与您确认需求</p>
                <p class="stateTxt" v-else>订单已完成</p>
                <div class="btn">
                    <span class="call-counselor" @click="callCounselor(true)">联系顾问</span>
                    <span class="look-details" @click="$router.push('/meetingDetails?id='+item.MettingID)">查看详情</span>
                </div>
            </li>
        </ul> -->
        <div :style="{'padding-top':$route.path=='/myOrder'?'none':'1.2rem'}" >
            <div class="order-list-item" v-for="(item,index) in list" :key="index" @click="$router.push('/meetingDetails?id='+item.MettingID)">
                <div class="item-header">
                    <p class="left">{{item.HoldingTime.split("T")[0].split("-")[1]}}.{{item.HoldingTime.split("T")[0].split("-")[2]}} | {{item.MettingVenue}} | {{item.NumberOfPeopleDesc}} | {{item.MettingTypeDesc}}</p>
                    <div class="right">{{item.IsSucceed?'已完成':'未完成'}}</div>
                </div>
                <div class="item-body">
                    <p v-if="!item.IsSucceed">等待顾问致电，与您确认需求</p>
                    <p v-else>订单已完成</p>
                </div>
                <div class="item-footer">
                    <div class="left">{{item.SubmissionTime|dateLong}}</div>
                    <div class="right">
                        <span class="r-btn" @click.stop="callCounselor(true)">联系顾问</span>
                        <span class="r-btn" @click="$router.push('/meetingDetails?id='+item.MettingID)">查看详情</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 联系顾问 -->
        <div v-show="isshowCounselor">
            <div class='lmy-mask-s'>
                <div class='lmy-modal'>
                    <div class='lmy-modal-head'>联系顾问</div>
                    <div class='lmy-modal-menu' >
                        <a href='tel:0755-82338117'>
                        <div class='line-a' >
                            <!-- <i class='iconfont icon-f-10'></i>点击拨打  -->
                                0755-82338117
                        </div>
                        </a>
                        <div class='line'>
                                值班时间
                            08:00-24:00
                        </div>
                    </div>
                    <div class='lmy-modal-foot'>
                            <div class='sort-btn'  @click="callCounselor(false)">取消</div>
                            <div class='sort-btn' >
                                <a href='tel:0755-82338117' style='color: #2391ff;'>拨打</a>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading @infinite="initData" ref="infiniteLoading">
		    <span slot="no-more">
		     没有更多了...
		    </span>
		    <span slot="no-results">
		     没有任何相关会议...
		    </span>
		    </infinite-loading>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
export default {
    components:{
        InfiniteLoading
    },
    data(){
        return {
            list:[],
            Page:1,
            PageSize:10,
            total:0,
            isshowCounselor:false,
        }
    },
    created(){
      // this.initData()
    },
    methods:{
        callCounselor(item){
            this.isshowCounselor = item
        },
        initData($state){
            var that = this
            if(that.total>0&&(((that.Page-1)*that.PageSize)>that.total)){
                $state.complete();
                return;
            }
            var params={
                Page:that.Page,
                PageSize:that.PageSize
            }
            that.postRequest({
                url: that.Api.MeetingSearch,
                params: params
            }).then(res => {
                if(res&&res.IsSuccess&&res.Result.length>0){
                  that.total=res.Total;
                  that.Page+=1;
                  that.list = that.list.concat(res.Result);
                  $state.loaded();
                }else{
                  $state.complete();
                }
            });
        }

    },
    mounted(){
        // this.query()
        // this.search()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/usr/meeting/list.vue